import { Component } from '@angular/core';
import { NavController,ToastController,AlertController,LoadingController } from 'ionic-angular';
import { HttpClient,HttpResponse } from '@angular/common/http';
import { Storage } from '@ionic/storage';

//types
import { ContactViewModel } from '../model/types';

//service
import { AppSharedService } from '../service/app_shared';

//page
import { LoginPage } from '../login/login';
import { MenuPage } from '../menu/menu';

@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html'
})
export class ContactPage {

  //class variable
  name:string;
  mobile:string;
  email:string;
  message:string;
  imageUrlResources  : string;
  
  //constructor
  constructor(
    public navCtrl: NavController,
    private toastController:ToastController,
    private alertCtrl:AlertController,
    private http: HttpClient,
    public appSharedService:AppSharedService,
    public loadingCtrl : LoadingController,
    public storage: Storage,
  ) {

    //initialize default value
    this.name="";
    this.mobile="";
    this.email="";
    this.message="";
    this.imageUrlResources= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/Images/AppResources/';
  }
  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  //validate details
  sendMail(){
     if(this.name.trim()==""){
        this.toastController.create({ message: "Please enter your name.", duration: 2000, showCloseButton: true }).present();
     }
     else if(this.mobile.trim()==""){
      this.toastController.create({ message: "Please enter mobile number.", duration: 2000, showCloseButton: true }).present();
     }
     else if(this.message.trim()==""){
      this.toastController.create({ message: "Please enter message.", duration: 2000, showCloseButton: true }).present();
     }
     else{
       this.sendFeedBack();
     }
  }

  //send feed back
  sendFeedBack(){
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    //initialize model
       var reg:ContactViewModel={
              ContactName: this.name,
              Email:this.email,
              Mobile:this.mobile,
              Messgae:this.message
       }
       var url= (this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlContactUs);
       
    // show loader
    loading.present();

       //do the service call
       this.http.post(url, reg, {observe: 'response'})
        .subscribe((res: HttpResponse<any>) => {   
            if(res.status==200){            
              
              let message=this.appSharedService.getHttpResponseMessage(res,'Your feedback submitted successfully. We will get back to you shortly!');

              // dismiss loader
              loading.dismiss();

              //show success message
              this.alertCtrl.create({
                  title: 'Success',
                  subTitle: message,
                  buttons: ['OK']
                }).present();

                this.clearFeedBack();
                
              }
              else if(res.status==204)
              {
                loading.dismiss();
                this.storage.clear();
                this.navCtrl.popToRoot();
                this.navCtrl.setRoot(LoginPage);
              }
              else{   
               
                let message=this.appSharedService.getHttpResponseMessage(res,'There is problem with sending feedback. please try after sometime!');

                // dismiss loader
              loading.dismiss();

              //show error message
                  this.alertCtrl.create({
                  title: 'Error',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
            }
        });
  }
  //clear the form
  clearFeedBack(){
    this.name="";
    this.mobile="";
    this.email="";
    this.message="";
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts